import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, Optional, AfterViewInit } from '@angular/core';
import { SessionService } from '../../@core/session/session.service';
import { AppLocalStorage } from "../../@core/utils/local-storage.util";
import { Store } from "../../@core/store/store";
import { marked } from 'marked';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import {
  profileImageLoadedState,
  profileImageLoadingErrorState,
  profileImageLoadingState,
} from "../../@core/session/session.state";
import { AiChatwootService } from './ai-chatwoot.service';
import { v4 as UUID } from "uuid";
import { GetChartFromSessionChainStartState, GetChartFromSessionLoadedState, GetChartFromSessionLoadingState, GetChartFromSessionModelEndState, GetChartFromSessionStreamChunkState, GetChartFromSessionToolEndState, GetChartFromSessionToolStartState, GetChartHIstoryLoadedState, GetChartHIstoryLoadingErrorState, GetChartHIstoryLoadingState, GetChartLoadedState, GetChartLoadingErrorState, GetChartLoadingState, GetTokenErrorState, PromptSpeakLoadedState, PromptSpeakLoadingState, TextSpeakLoadedState, TextSpeakLoadingState } from './ai-chartwoot-buddy.state';
import { NbSidebarService, NbToastrService, NbPopoverDirective } from '@nebular/theme';
import { Overlay } from '@angular/cdk/overlay';
import { stat } from 'fs';
import { AuthService } from '../../@core/auth/auth.service';
import { environment } from '../../../environments/environment';
import { UploadService } from './upload.service';
import { MsalService } from '@azure/msal-angular';
import { Observable, Subscription } from 'rxjs';
import { TokenService } from '../../@core/token/token.service';
import { name } from '@azure/msal-angular/packageMetadata';
import { UserTrackingService } from '../../@core/utils';
import { Router } from '@angular/router';


interface Leaf {
  name: string;
  title: string;
  enable: boolean;
  colorcode: string;
}

interface NestedCategory {
  subCategoryName: string;
  title: string;
  enable: boolean;
  colorcode: string;
  data: Leaf[];
}

interface TopCategory {
  categoryName: string;
  title: string;
  enable: boolean;
  colorcode: string;
  data: (Leaf | NestedCategory)[];
}

export interface DropDownData {
  code: string;
  name: string;
  attachment_required: boolean;
}

// Add this interface to your component file
export interface FileUploadStatus {
  file: File;
  progress: number;
  message: string;
  webUrl?: string; // Optional if you want to display the URL
}

export interface fileSizeArr {
  name: string,
  size: number
}

interface ChatMessage {
  from: string;
  text: string | SafeHtml;
  avatar: string;
  tagMsg: string;
  tags: string[];
  thinking: boolean;
  streaming?: boolean;
  timestamp: any;
  type?: 'text' | 'attendance';
  attendanceType?: 'regularization' | 'leave';
  dropdownData?: DropDownData[];
  componentData?: any;
  disabled?: boolean;
  isValidated?: boolean;
}


@Component({
  selector: 'app-ai-chatwoot-buddy',
  templateUrl: './ai-chatwoot-buddy.component.html',
  styleUrls: ['./ai-chatwoot-buddy.component.scss']
})
export class AiChatwootBuddyComponent implements OnInit, AfterViewInit {


  /**
   * Streams chat responses using WebSocket and updates the UI in real-time.
   */



  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ViewChild('LINAInput') LINAInput!: ElementRef;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  employeeName: string;
  greetingMessage: string;
  loading = true;
  profileData: any = {};
  username: any;
  profileimage: any;
  accountData: any;
  promptLibraryTag: boolean = false;
  data: any;
  chartHistorydata: any;
  showOverlay = false;
  showOverlayLINA = false;
  getsessionId: any;
  newsessionId: any;
  historySection: boolean = false;
  promtSection: boolean = false;
  sessionData: any;
  categories: any;
  selectedCategory: string | null = null;
  questions: string[] = [];
  textindex: boolean = false;
  openAlinaPopup: boolean = false;
  showOnLoad: boolean = true;
  messages: Array<{
    from: string;
    text: string | SafeHtml;
    avatar: string;
    tagMsg: string;
    tags: string[];
    thinking: boolean;
    streaming?: boolean;
    timestamp: any;
    type?: 'text' | 'attendance';
    attendanceType?: 'regularization' | 'leave';
    dropdownData?: DropDownData[];
    componentData?: any;
    disabled?: boolean;
    feedback?: 'liked' | 'disliked';
    showFeedbackInput?: boolean;
    feedbackText?: string;
    chat_history_id?: string;
    feedbackSubmitted?: boolean;
    isInitialMessage?: boolean;
  }> = [];
  showAll: boolean = false;
  disableInput: boolean = false;
  showmore: boolean = false;
  viewAllText: string = 'View All';
  selectedIndex: number | null = null
  selectedQuestionIndex: any;
  SelectLength: number = 1;
  inputMessage = '';
  dropdownData!: DropDownData[];
  aiThinking = false;
  isSpeaking: boolean = false;
  audioUrl: string | null = null;
  isPlaying: boolean = false;
  @ViewChild('audioPlayer') audioPlayer: any;
  compileMsg = "Compiling the details you need - almost there";
  stopBtn: any;
  speakBtn: any;
  pauseBtn: any;
  audioPlayerTag = document.getElementById('audioPlayer');
  calType!: 'regularization' | 'leave';
  // Speech-to-text properties
  isRecording = false;
  isTranscribing = false;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  audioContext: AudioContext | null = null;
  analyser: AnalyserNode | null = null;
  silenceTimer: any = null;
  silenceThreshold = 30; // Adjust this value (0-255) for sensitivity
  silenceTimeout = 2000; // 2 seconds of silence before stopping
  disableInputTrue: boolean = true;
  plainText: string;
  startStreaming = false;
  endTooling = false;
  startAgent = false;
  activeAttendanceMessage: any = null;
  //new
  promptLibrary: TopCategory[] = [];
  sortedLibrary = [];
  selectedTopIndex: number | null = null;
  selectedNestedIndex: number | null = null
  selectedSubcategory: null;
  subcategories: any;
  selectedCategoryName: any;
  selectedTabIndex: any;
  showUserGuide: boolean = false;
  private cmsbase_url: string;

  //file Upload
  accessToken: string = '';
  bearerToken: string = '';
  sessionId: string = '';
  selectedFiles: File[] = [];
  maxFileCount = 15;
  // selectedFiles: UploadedFile[] = [];
  uploadProgressMap: { [key: string]: number } = {};
  uploadStatusMap: {
    [key: string]: 'pending' | 'uploading' | 'success' | 'error';
  } = {};
  messageMap: { [key: string]: string } = {};
  isUploading: boolean = false;
  allFilesUploaded: boolean = false;
  uploadSummary: string = '';
  uploadedFiles: any;
  uploadedFileUrls = [];
  fileUploadFlag: boolean;
  @ViewChild('fileInput') fileInput!: ElementRef;
  ImageString: string;
  showremaining: boolean = false;
  isFilesSelected: boolean = false;
  ulpoadedFilesHtml: any = [];
  filesHtml: string;
  itemLimit: number;
  count: number = 0;
  uploadProgress$: Observable<number> | null = null;
  uploadStatus$: Observable<string> | null = null;
  uploadProgress: number = 0;
  progressSubscription!: Subscription;
  fileSize: any;
  intialFileSize: any;
  uploadProgressText: string;
  filesToUpload: fileSizeArr[] = [];
  errorFileUpload: boolean = false;
  previousFileName: string = '';
  LINANAME: string;
  MobileLINAMenu: boolean = false;
  isInTeams = window.parent !== window.self;
  isHeadersDisable = true;

  


  constructor(private sessionService: SessionService,
    private cdr: ChangeDetectorRef,
    private AiChatwootService: AiChatwootService,
    private toastrService: NbToastrService,
    private sidebarService: NbSidebarService,
    private AuthService: AuthService,
    private sanitizer: DomSanitizer,
    private uploadService: UploadService,
    private msalService: MsalService,
    private tokenService: TokenService,
    private userTrackingService: UserTrackingService,
    private router: Router,
  ) {

  }

  themes = [
    { value: 'light', label: 'Light', icon: 'sun-outline' },
    { value: 'dark', label: 'Dark', icon: 'moon-outline' },
    { value: 'corporate', label: 'Corporate', icon: 'briefcase-outline' },
    { value: 'blue', label: 'Blue', icon: 'droplet-outline' }
  ];

  theme: 'light' | 'dark' | 'corporate' | 'blue' = 'light';

  ngOnInit(): void {
    this.accountData=AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
    this.cmsbase_url = environment.CMSURL_IMG;
    this.LINANAME = environment.LINA_NAME;
    this.sessionService.userConfigData$.subscribe((data) => {
      this.employeeName = data.profile.employeeName
    });
    this.getUserProfileData();
    this.setGreetingMessage();
    this.getPromptData();
    // this.fileUploadFlag = window['env']?.myteams == 'true';
    this.fileUploadFlag = true;
    //session ID
    if (!this.newsessionId) {
      this.newsessionId = sessionStorage.setItem('chatSessionId', UUID());
      this.newsessionId = UUID();
    } else {
      this.newsessionId = sessionStorage.getItem('chatSessionId');
    }

    this.getChartHistory();

    this.messages = [
      {
        from: 'agent',
        text: 'Hi ' + this.employeeName + ', I am ' + this.LINANAME + ', your Digital AI Associate. I hope your day is going well. What can I assist you with?', //'Hello! 👋 How can I help you today?',
        avatar: '/assets/images/smiley.png',
        tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
        tags: Object.keys(this.promptLibrary).sort(),
        thinking: false,
        timestamp: new Date()
      }
    ];
    // this.getFilesReadWriteToken();
    // if(this.isInTeams){
      this.getstart();
    // }
  }

  ngAfterViewInit(): void {
    // Check for initial prompt from widget and auto-submit
    const initialPrompt = localStorage.getItem('LEINA_INITIAL_PROMPT');
    if (initialPrompt) {
      localStorage.removeItem('LEINA_INITIAL_PROMPT');
      // Skip loading screen and go directly to chat
      this.loading = false;
      this.getstart();
      // Use setTimeout to ensure view is fully rendered
      setTimeout(() => {
        this.inputMessage = initialPrompt;
        if (this.scrollContainer?.nativeElement) {
          this.sendMessage(this.scrollContainer.nativeElement);
        }
      }, 100);
    }
  }

formatFullTime(date: any): string {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'short' }); // January, November
  const year = d.getFullYear().toString().slice(-2);


  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');

  // Output → "21-November-2025 13:57"
  return ` ${hours}:${minutes} ${day}-${month}-${year}`;
}



  // get started with LINA
  getstart() {
    this.userTrackingService.track('LINA_clicked', {'value':'Get Started'}, 'LINA');
    this.loading = false;
    this.selectedQuestionIndex = null;
    this.selectedIndex = null;
    this.inputMessage = '';
    this.selectedTabIndex = null;
    this.selectedIndex = null;
    this.selectedFiles = [];
    this.isFilesSelected = false;
    this.messages = [
      {
        from: 'agent',
        text: 'Hi ' + this.employeeName + ', I am ' + this.LINANAME + ', your Digital AI Associate. I hope your day is going well. What can I assist you with?', //'Hello! 👋 How can I help you today?',
        avatar: '/assets/images/smiley.png',
        tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
        tags: Object.keys(this.promptLibrary).sort(),
        thinking: false,
        timestamp: new Date()
      }
    ];
    this.selectedIndex = null;
    this.showOnLoad = true;
    this.SelectLength = this.messages.length;
  }

  // New Chart
  startNewChat(scrollContainer) {
    this.userTrackingService.track('LINA_New_Chat_Clicked', {'value':'Start New Chat'}, 'LINA');
    this.newsessionId = UUID();
    this.loading = false;
    this.selectedQuestionIndex = null;
    this.selectedIndex = null;
    this.selectedCategory = '';
    this.questions = [];
    this.inputMessage = '';
    this.subcategories = '';
    this.selectedTabIndex = null;
    if(this.showOverlayLINA && this.MobileLINAMenu){
      this.showOverlayLINA = false;
      this.MobileLINAMenu = false;
    }

    this.messages = [
      {
        from: 'agent',
        text: 'Hi ' + this.employeeName + ', I am ' + this.LINANAME + ', your Digital AI Associate. I hope your day is going well. What can I assist you with?', //'Hello! 👋 How can I help you today?',
        avatar: '/assets/images/smiley.png',
        tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
        tags: Object.keys(this.promptLibrary).sort(),
        thinking: false,
        timestamp: new Date()
      }
    ];
    this.showPromptLibrary('New Chat', scrollContainer);
    this.getChartHistory();
  }

  goBackHome() {
    this.userTrackingService.track(
      'Home_clicked',
      { value: 'Home' },
      'LINA',
    );
   if(this.isHeadersDisable){
      this.router.navigate(["home"]);
    }else{
       this.loading=true;
    }
  }

  setGreetingMessage(): void {
    const currentHour = new Date().getHours();
    if (currentHour >= 5 && currentHour < 12) {
      this.greetingMessage = 'Good Morning!';
    } else if (currentHour >= 12 && currentHour < 17) {
      this.greetingMessage = 'Good Afternoon';
    } else if (currentHour >= 17 && currentHour < 24) {
      this.greetingMessage = 'Good Evening!';
    } else {
      this.greetingMessage = 'Good Evening!';
    }
  }

  getUserProfileData() {
    this.profileData = AppLocalStorage.get("PROFILE_DATA", "PROFILE_DATA");
    this.username = this.profileData?.employeeName;
    this.getProfileImage(this.accountData.profile);
  }

  openUserGuide() {
    this.showUserGuide = true;
    this.userTrackingService.track('LINA_User_Guide_clicked', {'value':'Opened'}, 'LINA');
    if(this.showOverlayLINA && this.MobileLINAMenu){
      this.showOverlayLINA = false;
      this.MobileLINAMenu = false;
    }
  }

  closeUserGuide() {
    this.showUserGuide = false;
    this.userTrackingService.track('LINA_User_Guide_clicked', {'value':'Closed'}, 'LINA');
  }

  getProfileImageSrc(image: string): string {
    if (image && image.startsWith("data:image/png;base64,")) {
      return image;
    }
    else if (image && !image.startsWith("data:image/png;base64,")) {
      return "data:image/png;base64," + image;
    }
    else {
      return this.cmsbase_url + "wp-content/uploads/2025/05/dumy.jpg";
    }
  }

  getPromptData() {
    let emailId = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")?.profile?.email;
    const reqBody = {
      email: emailId
    }
    this.AiChatwootService.getAlinaPrompt(reqBody).subscribe({
      next: (state: Store.State) => {
        if (state instanceof PromptSpeakLoadingState) {
          //loading
        } else if (state instanceof PromptSpeakLoadedState) {
          var promptData = state.data.data.map(item => {
            return {
              ...item,
              created_date: this.formatDateToLocal(item.created_date + "Z")
            };
          });
          this.promptLibrary = promptData;
        }
      },
      error: (error) => {
        this.toastrService.danger("Failed to fetch data. Please try again later.", "Error", { duration: 3000 });
      }
    });
  }

  getFilesReadWriteToken() {
    const request = {
      scopes: ['Files.ReadWrite.All']
    };
    return this.msalService.instance.acquireTokenSilent(request)
      .then(response => {
        this.accessToken = response.accessToken;
        return response.accessToken;
      })
      .catch(() =>
        this.msalService.instance.acquireTokenRedirect(request)
      );
  }


  async onFilesSelected(event: any) {
    const files = event.target.files;
    // console.log('event.target.files', files);
    this.userTrackingService.track('LINA_File_Upoad_clicked', {'value': files}, 'LINA');
    if (files.length + this.selectedFiles.length > this.maxFileCount) {
      this.toastrService.danger("You can only select a maximum of " + this.maxFileCount + " files.", "Error", { duration: 5000 });
      //Clear the file input value to prevent the selection
      event.target.value = '';
      if (!this.selectedFiles) {
        this.selectedFiles = [];
        this.isFilesSelected = false;
      }
    } else {
      const newFiles: FileList = event.target.files;
      if (newFiles && newFiles.length > 0) {
        for (let i = 0; i < newFiles.length; i++) {
          const newFile = newFiles[i];
          // Check if a file with the same name and size/lastModified date exists
          const isDuplicate = this.selectedFiles.some(
            existingFile => existingFile.name === newFile.name && existingFile.lastModified === newFile.lastModified
          );
          if (!isDuplicate) {
            this.selectedFiles.push(newFile);
            this.uploadStatusMap[newFile.name] = 'pending';
            if (this.selectedFiles) {
              this.isFilesSelected = true;
            } else {
              this.isFilesSelected = false;
            }
            this.bearerToken = localStorage.getItem('sso_token');
            const bearerToken = await this.tokenService.getAccessToken();
            this.getFilesReadWriteToken();
            this.sessionId = this.newsessionId;
          }
        }
      }
    }

  }

  async onUpload(scrollContainer: HTMLElement) {
    if (!this.selectedFiles.length || !this.accessToken || !this.bearerToken) {
      this.toastrService.danger('Please select files', 'Error', { duration: 5000 });
      return;
    }

    // Reset state for new upload batch
    this.isUploading = true;
    this.allFilesUploaded = false;
    this.uploadSummary = '';
    this.uploadProgressMap = {};
    this.messageMap = {};
    this.disableInput = true;


    const totalFiles = this.selectedFiles.length;

    // Create upload promises for all files
    const uploadPromises = this.selectedFiles.map(file =>
      this.uploadSingleFile(file)
    );

    try {
      // Wait for all uploads to complete
      await Promise.all(uploadPromises);
      // All uploads completed - generate summary
      this.completeAllUploads(totalFiles, scrollContainer);

    } catch (error) {
      // console.error('Error during parallel uploads:', error);
      this.completeAllUploads(totalFiles, scrollContainer);
    }
  }

  bytesToMB(bytes: number): string {
    if (bytes < 0) {
      throw new Error("Bytes cannot be a negative value.");
    }
    return (bytes / (1024 * 102)).toFixed(2) // Divide by 1024 for KB, then by 1024 again for MB
  }

  getSafeClassName(filename: string): string {
    return filename
      .replace(/\s/g, '-') // Replace spaces with hyphens
      .replace(/[^\w-]/g, '') // Remove non-alphanumeric characters except hyphens
      .toLowerCase(); // Convert to lowercase for consistency
  }

  // uploadStatusMap: Map<string, FileUploadStatus> = new Map();

  async uploadSingleFile(file: File): Promise<void> {
    const totalFiles = this.selectedFiles.length;
    if (!file) {
      return;
    }
    try {
      this.uploadStatusMap[file.name] = 'uploading';
      this.uploadProgressMap[file.name] = 0;

      // Call the service and await the final response
      const finalResult = await this.uploadService.uploadFileInChunks(
        file,
        this.accessToken,
        this.bearerToken,
        this.sessionId,
        (percent) => {
          this.uploadProgressMap[file.name] = Math.round(percent);

          if (this.previousFileName != file.name) {
            this.count++;
            this.previousFileName = file.name;
          }

          if (percent) {
            var elemid = document.getElementById('mybar' + this.count + '');
            if (elemid)
              elemid.style.display = "block";
            var errorMsg = document.getElementById('mybarErroe' + this.count + '');
            var errorMsg1 = document.getElementById('mybarErroe1' + this.count + '');
            if (errorMsg) {
              errorMsg.style.display = "none";
            }
            if (errorMsg1) {
              errorMsg1.style.display = "none";
            }
          } else {
            this.uploadProgress = 0;
            var errorMsg = document.getElementById('mybarErroe' + this.count + '');
            var errorMsg1 = document.getElementById('mybarErroe1' + this.count + '');
            if (errorMsg) {
              errorMsg.style.display = "block";
            }
            if (errorMsg1) {
              errorMsg1.style.display = "block";
            }
            var elemid = document.getElementById('mybar' + this.count + '');
            elemid.style.display = "block";
            elemid.style.background = "#f00";
          }
        }
      );
      // ✅ Push the final result into the array
      if (finalResult.data) {
        this.messageMap[file.name] = 'File uploaded successfully';
        this.uploadStatusMap[file.name] = 'success';
        this.count = 0;
        this.ulpoadedFilesHtml.push({ data: finalResult.data, fileName: file.name });
        this.toastrService.success(finalResult.message || 'File uploaded successfully!', 'Success');
      } else {
        this.uploadStatusMap[file.name] = 'error';
        this.toastrService.warning('Upload succeeded, but no data was returned.', 'Warning');
      }

    } catch (error: any) {
      this.toastrService.danger(error.message, 'Error', { duration: 5000 });
      // Reset progress or handle error state
      this.uploadStatusMap[file.name] = 'error';
      this.uploadProgress = 0;
      // this.messageMap[file.name] = 'Upload failed';
      if (totalFiles == this.count) {
        this.isFilesSelected = false;
        this.count = 0;
        this.disableInput = false;
        this.inputMessage = '';
        const fileInput = document.getElementById('file-input') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = ''; // Reset the input value
        }
      }
    }
  }
  private completeAllUploads(total: number, scrollContainer: HTMLElement) {

    this.isUploading = false;
    this.allFilesUploaded = true;

    this.uploadService.uploadFileInChunks
    const successful = Object.values(this.uploadStatusMap).filter(
      (status) => status === 'success',
    ).length;
    const failed = total - successful;

    this.uploadSummary = `Upload Complete: ${successful} successful, ${failed} failed out of ${total} files`;
    // return;
    if (this.ulpoadedFilesHtml) {
      var children = '';
      this.ulpoadedFilesHtml.map(file => {
        children += "<a style='color: #FFF;' target='_blank' [nbTooltip]=" + file?.fileName + " href=" + file?.data?.webUrl + ">" + file?.fileName + "</a>";
      });
      this.filesHtml = "<div>" + children + "</div>";
    }
    this.selectedFiles = [];
    this.count = 0;
    this.isFilesSelected = false;
    const fileInput = document.getElementById('file-input') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset the input value
    }
    const msg = this.inputMessage.trim() + ' ' + this.filesHtml;
    // return;
    if (msg && successful >= 1) {
      this.selectedFiles = [];
      this.disableInput = true;
      this.selectedCategory = ''
      this.questions = []
      this.showOnLoad = true;
      this.subcategories = '';
      this.selectedTabIndex = null;
      this.selectedIndex = null;
      if (!msg) return;
      this.inputMessage = '';
      this.selectedCategory = null;
      this.count = 0;
      this.ulpoadedFilesHtml = []
      this.getTextFromSessionStreamUI(this.newsessionId, msg, scrollContainer);
      this.userTrackingService.track('LINA_Question_Submitted', {'value':msg}, 'LINA');
      setTimeout(() => {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }, 300);
    } else {
      if(this.inputMessage && successful < 1){
        this.toastrService.danger("File upload failed", "Error", { duration: 3000 });
        
      }else{

        this.toastrService.danger("Please enter something...", "Error", { duration: 3000 });
      }
      this.disableInput=false;
    }

  }

  removeFile(fileName): void {
    this.selectedFiles = this.selectedFiles.filter(
      (file) => file.name !== fileName,
    );
    delete this.uploadProgressMap[fileName];
    // delete this.uploadStatusMap[filename];
    
    this.userTrackingService.track('LINA_Remove_File_clicked', {'value': fileName}, 'LINA');
    if (this.selectedFiles.length > 0) {
      this.isFilesSelected = true;
    } else {
      this.isFilesSelected = false;
    }
    const fileInput = document.getElementById('file-input') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset the input value
    }
  }

  showremainingFiles(): void {
    this.showremaining = !this.showremaining;
    const fileInput = document.getElementById('file-input') as HTMLInputElement;
    this.userTrackingService.track('LINA_Show_All_Files_clicked', {'value': fileInput.value }, 'LINA');
  }



  getProfileImage(user) {
    const me = this;
    const id = [user?.email];

    if (AppLocalStorage.get("PROFILE_IMAGE", "PROFILE_IMAGE" + String(id).toLowerCase())) {
      me.profileData = {
        ...me.profileData,
        profileImage: null
      };
      me.profileimage = this.getProfileImageSrc(AppLocalStorage.get("PROFILE_IMAGE", "PROFILE_IMAGE" + String(id).toLowerCase())[0]?.userImage);
    } else {
      me.sessionService.getProfileImage(id).subscribe((state: Store.State) => {
        if (state instanceof profileImageLoadingState) {
          return;
        }
        if (state instanceof profileImageLoadedState) {
          me.profileData = {
            ...me.profileData,
            profileImage: null
          };
          me.profileimage = this.getProfileImageSrc(state.data?.data[0]?.userImage);
          me.cdr.detectChanges();
          return;
        }
        (state: profileImageLoadingErrorState) => {
          return;
        };
      });
    }
  }
getSafeHtml(html: string): SafeHtml {
  return this.sanitizer.bypassSecurityTrustHtml(html);
}
  removePreTags(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Select all <pre> tags in the document
    const preElements = doc.querySelectorAll('pre');
    // Iterate and remove each <pre> tag
    preElements.forEach(pre => {
      pre.remove();
    });
    // Return the modified HTML string
    return doc.body.innerHTML;
  }


  htmlToPlainText(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  pause(speakBtnID: string, pauseBtnId: string): void {
    this.speakBtn = document.getElementById(speakBtnID);
    this.pauseBtn = document.getElementById(pauseBtnId);
    if (this.audioPlayer && this.audioPlayer.nativeElement) {
      const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
      if (audio && !audio.paused) {
        audio.pause();
        if (this.speakBtn) this.speakBtn.style.display = 'inline-block';
        if (this.pauseBtn) this.pauseBtn.style.display = 'none';
      }
    }
  }

  //get word count
  getWordCount(str) {
    return str.trim().split(/\s+/).length;
  }

  //read the text
  async readText(text, speakBtnID, pauseBtnID) {
    this.userTrackingService.track('LINA_Text_To_Speach_clicked', {'value': text}, 'LINA');
    if (this.speakBtn) this.speakBtn.style.display = 'inline-block';
    if (this.pauseBtn) this.pauseBtn.style.display = 'none';
    this.speakBtn = document.getElementById(speakBtnID);
    this.pauseBtn = document.getElementById(pauseBtnID);
    this.plainText = this.htmlToPlainText(text);
    const chunkSize = 200;
    const chunks = [];
    const words = this.plainText.split(/\s+/);
    let currentChunk = "";
    for (const word of words) {
      if ((currentChunk + " " + word).trim().length <= chunkSize) {
        currentChunk += (currentChunk ? " " : "") + word;
      } else {
        chunks.push(currentChunk);
        currentChunk = word;
      }
    }

    if (currentChunk) {
      chunks.push(currentChunk);
    }

    const audioPlayer = this.audioPlayer.nativeElement || document.getElementById('audioPlayer');
    audioPlayer.src = '';

    let playbackQueue = [];
    let playing = false;
    let nextToPlay = 0;

    const baseUrl = environment.api.core.base
    const path = environment.api.genie.speak.endpoint;
    const token = await this.tokenService.getAccessToken();

    const self = this;
    if (self.speakBtn) {
      self.speakBtn.style.display = 'none';
    }
    async function fetchChunk(idx) {
      if (idx >= chunks.length) return;
      const payload = { text_to_speak: chunks[idx] };
      try {
        const response = await fetch(baseUrl + path, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Authorization": 'Bearer ' + token
          },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('TTS failed for chunk');

        const buffer = await response.arrayBuffer();
        const blob = new Blob([buffer], { type: 'audio/mpeg' });
        playbackQueue[idx] = blob;
        // If not playing, start playback
        if (!playing) playNextInQueue();
        // Start fetching the next chunk immediately
        await fetchChunk(idx + 1);
      } catch (err) {
        //error msg
      }
    }

    function playNextInQueue() {
      if (nextToPlay < playbackQueue.length) {
        audioPlayer.src = URL.createObjectURL(playbackQueue[nextToPlay]);
        audioPlayer.style.display = "block";
        if (self.pauseBtn) self.pauseBtn.style.display = 'inline-block';
        audioPlayer.play();
        playing = true;
        audioPlayer.onended = () => {
          playing = false;
          nextToPlay++;
          if (nextToPlay >= playbackQueue.length) {
            if (self.pauseBtn) self.pauseBtn.style.display = 'none';
            if (self.speakBtn) self.speakBtn.style.display = 'inline-block';
          } else {
            playNextInQueue();
          }
        };
      }
    }

    if (self.pauseBtn) self.pauseBtn.style.display = 'inline-block';
    fetchChunk(0);
  }


  stop(speakBtnID, stopBtnId) {
    this.speakBtn = document.getElementById(speakBtnID);
    this.stopBtn = document.getElementById(stopBtnId);
    this.pauseBtn = document.getElementById('pauseBtn' + speakBtnID.replace('playBtn', ''));
    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    audio.pause();
    audio.currentTime = 0;
    if (this.stopBtn)
      this.stopBtn.style.display = 'none';
    if (this.speakBtn)
      this.speakBtn.style.display = 'inline-block';
    if (this.pauseBtn)
      this.pauseBtn.style.display = 'none';
  }


  selectCategory(category: any, i, scrollContainer: HTMLElement) {
    this.userTrackingService.track('LINA_Prompt_clicked', {'value': category, 'Type':'Main Category'}, 'LINA');
    this.textindex = true;
    this.subcategories = category.sort();
    this.selectedSubcategory = null;
    this.selectedTabIndex = i;
    this.selectedCategory = '';
    this.selectedIndex = null;
    setTimeout(() => {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    });
  }


  promptLibraryshow(category, i, name, scrollContainer: HTMLElement) {
    this.userTrackingService.track('LINA_Prompt_clicked', {'value': name, 'Type':'Sub Category'}, 'LINA');
    this.textindex = true;
    this.selectedCategoryName = name;
    this.selectedQuestionIndex = null;
    this.selectedCategory = category;
    this.questions = category;
    this.showmore = false;
    this.viewAllText = 'View More';
    this.selectedIndex = i;
    this.itemLimit = 5;
    if (this.questions.length > 5)
      this.showAll = true
    else
      this.showAll = false
    setTimeout(() => {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    });
  }

  showPromptLibrary(chatFlag, scrollContainer: HTMLElement) {
    this.selectedIndex = null;
    this.showOnLoad = true;
    this.SelectLength = this.messages.length;
    if(this.showOverlayLINA && this.MobileLINAMenu){
      this.showOverlayLINA = false;
      this.MobileLINAMenu = false;
    }
    if(chatFlag === "Show Prompt"){
      this.userTrackingService.track('LINA_MyCatalog_clicked', {'value':'MyCatalog'}, 'LINA');
    }

    setTimeout(() => {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    });
  }

  useThisText(text, scrollContainer: HTMLElement, i) {
    this.inputMessage = text;
    this.LINAInput.nativeElement.focus();
    this.selectedQuestionIndex = i;
    scrollContainer.scrollTop = scrollContainer.scrollHeight;
    this.userTrackingService.track('LINA_Prompt_clicked', {'value':text}, 'LINA');
  }

  copyText(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      const text = element.textContent || '';
      this.userTrackingService.track('LINA_Copy_clicked', {'value':  text}, 'LINA');
      navigator.clipboard.writeText(text)
        .then(() => {
        })
        .catch(err => console.error('Copy failed:', err));
    }

  }

  closeAlina() {
    this.openAlinaPopup = !this.openAlinaPopup;
    if(this.openAlinaPopup){
      this.userTrackingService.track('LINA_About_clicked', {'value':'Opened'}, 'LINA');
    }else{
      this.userTrackingService.track('LINA_About_clicked', {'value':'Closed'}, 'LINA');
    }
  }

  getTextFromSession(item, scrollContainer: HTMLElement) {
    let emailId = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")?.profile?.email;
    this.newsessionId = item.session_id;
    this.userTrackingService.track('LINA_History_Session_clicked', {'value':item.session_id}, 'LINA');

    this.AiChatwootService.getTextFromSession(item.session_id, emailId, this.accessToken).subscribe({
      next: (state: Store.State) => {
        if (state instanceof GetChartFromSessionLoadingState) {
          //loading
        } else if (state instanceof GetChartFromSessionLoadedState) {
          this.sessionData = state.data.data;
          this.messages = [
            {
              from: 'agent',
              text: 'Hi ' + this.employeeName + ', I am ' + this.LINANAME + ', your Digital AI Associate. I hope your day is going well. What can I assist you with?', //'Hello! 👋 How can I help you today?',
              avatar: '/assets/images/smiley.png',
              tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
              tags: Object.keys(this.promptLibrary).sort(),
              thinking: false,
              timestamp: new Date()
            }
          ];
          if (this.sessionData) {
            this.sessionData.history.map((data) => {
              let historyDate = new Date(); // Default to now if missing
            if (data.timestamp) {
              let timeStr = data.timestamp;
              // If the string doesn't end in Z, append it to force UTC interpretation
              if (typeof timeStr === 'string' && !timeStr.endsWith('Z') && !timeStr.includes('+')) {
                timeStr += 'Z';
              }
              historyDate = new Date(timeStr);
            }
              if (data.role == 'user') {
                this.messages.push({
                  from: 'user',
                  text: data.content,
                  avatar: this.getProfileImageSrc(this.profileimage),
                  tagMsg: '',
                  tags: [],
                  thinking: false,
                  timestamp: historyDate
                });
              } else {
                this.removeAiThinking();
                this.messages.push({
                  from: 'agent',
                  text: this.sanitizer.bypassSecurityTrustHtml(this.parseMarkdown(data.content)),
                  avatar: 'assets/images/smiley.png',
                  tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
                  tags: Object.keys(this.promptLibrary).sort(),
                  thinking: false,
                  timestamp: historyDate
                });
              }
            })
            this.closePopup();
          }
        }
      },
      error: (error) => { }
    });
    this.selectedCategory = ''
    this.questions = []
    this.showOnLoad = true;
    this.subcategories = '';
    this.selectedTabIndex = null;
    this.selectedIndex = null;
    setTimeout(() => {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }, 300);
    return
  }

  getChatBotData(Inputtext, scrollContainer) {
    let emailId = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")?.profile?.email;
    const reqBody = {
      query: Inputtext, //share my manager details
      email: emailId,
      session_id: this.newsessionId
    }

    this.AiChatwootService.getChatData(reqBody).subscribe({
      next: (state: Store.State) => {
        if (state instanceof GetChartLoadingState) {
          //loading
        } else if (state instanceof GetChartLoadedState) {
          this.data = state.data.data;
          if (this.data) {
            this.removeAiThinking();
            this.messages.push({
              from: 'agent',
              text: this.data.response,
              avatar: '/assets/images/smiley.png',
              tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
              tags: Object.keys(this.promptLibrary).sort(),
              thinking: false,
              timestamp: this.data.created_at ? new Date(this.data.created_at) : new Date()
            });
          } else {
            this.removeAiThinking();
            this.messages.push({
              from: 'agent',
              text: 'Thanks for asking! I’m still learning and haven’t been trained on this topic yet. While I can’t help with it today, I’m working hard to grow better every day. Appreciate your patience and curiosity!',
              avatar: '/assets/images/smiley.png',
              tagMsg: '',
              tags: [],
              thinking: false,
              timestamp: this.data.created_at ? new Date(this.data.created_at) : new Date()
            });
          }
          this.disableInput = false;
        }
      },
      error: (error) => {
        this.removeAiThinking();
        this.messages.push({
          from: 'agent',
          text: 'Thanks for asking! I’m still learning and haven’t been trained on this topic yet. While I can’t help with it today, I’m working hard to grow better every day. Appreciate your patience and curiosity!',
          avatar: '/assets/images/smiley.png',
          tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
          tags: Object.keys(this.promptLibrary).sort(),
          thinking: false,
          timestamp:new Date
        });
        this.disableInput = false;
        this.toastrService.danger("Failed to fetch data. Please try again later.", "Error", { duration: 3000 });
      }
    });
    setTimeout(() => {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }, 300);
    return
  }
  localTimeSet(dateStr){
    let normalized = dateStr;
    if (!/[Z+-]/.test(dateStr)) {
      normalized += "Z";
    }

    const date = new Date(normalized);
    return date
  }
  formatDateToLocal(dateStr) {
    // Normalize input -> ensure it's treated as UTC if no timezone suffix
    let normalized = dateStr;
    if (!/[Z+-]/.test(dateStr)) {
      normalized += "Z";
    }

    const date = new Date(normalized);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 -> 12, 13 -> 1 etc.
    const hourStr = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${hourStr}:${minutes} ${ampm}`;
  }

  getChartHistory() {
    let emailId = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")?.profile?.email;
    this.AiChatwootService.getHistoryData(emailId).subscribe({
      next: (state: Store.State) => {
        if (state instanceof GetChartHIstoryLoadingState) {
          //loading
        } else if (state instanceof GetChartHIstoryLoadedState) {
          var historydata = state.data.data.map(item => {
            return {
              ...item,
              created_date: this.formatDateToLocal(item.created_date + "Z")
            };
          });
          this.chartHistorydata = historydata;
        }
      },
      error: (error) => {
        this.toastrService.danger("Failed to fetch data. Please try again later.", "Error", { duration: 3000 });
      }
    })
  }

  showAllitem() {
    if (this.showmore && this.itemLimit >= this.questions.length) {
      this.showmore = false;
      this.viewAllText = 'View More';
      this.itemLimit = 5;
      this.userTrackingService.track('LINA_Prompt_View_More_clicked', {'value':'View More'}, 'LINA');
    }
    else {
      if (this.itemLimit <= this.questions.length) {
        this.showmore = true;
        this.itemLimit += 5;
        if (this.itemLimit >= this.questions.length) {
          this.viewAllText = 'View less';
          this.userTrackingService.track('LINA_Prompt_View_Less_clicked', {'value':'View Less'}, 'LINA');
        }
      }
    }
  }

  get canLoadMore(): boolean {
    return this.itemLimit < this.questions.length;
  }

  getCategories(): string[] {
    return Object.keys(this.promptLibrary).sort();
  }

  // getMnACategories(): string[] {
  //   return Object.keys(this.MergersAcquisition).sort();
  // }

  sendMessage(scrollContainer: HTMLElement) {
    const msg = this.inputMessage.trim();

    if (!msg) {
      this.toastrService.danger('Please enter something...', 'Error', {
        duration: 3000,
      });
      return;
    }

    this.messages.forEach((message) => {
      if (message.type === 'attendance') {
        message.disabled = true;
      }
    });
    this.activeAttendanceMessage = null; // Clear active attendance message as all are now disabled
    if (this.selectedFiles.length) {
      // console.log('selectedFiles', this.selectedFiles.length)
      this.onUpload(scrollContainer);
    } else {
      // console.log('inside checkindf g===============================')
      this.disableInput = true;
      this.selectedCategory = '';
      this.questions = [];
      this.showOnLoad = true;
      this.subcategories = '';
      this.selectedTabIndex = null;
      this.selectedIndex = null;
      this.inputMessage = '';

      this.selectedCategory = null;
      this.getTextFromSessionStreamUI(this.newsessionId, msg, scrollContainer);
      this.userTrackingService.track(
        'LINA_Question_Submitted',
        { value: msg },
        'LINA',
      );
      setTimeout(() => {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }, 300);
    }
  }

  onAttendanceOptionChange(option: string, msg: any) {
    msg.selectedOption = option;

  }

  onAttendancePromptChange(prompt: string) {
    console.log('onAttendancePromptChange called with:', prompt);
    this.inputMessage = prompt;
  }

  canSendAttendanceMessage(): boolean {
    // Check if there's an active attendance message
    if (!this.activeAttendanceMessage) {
      return true; // Regular messages can always be sent
    }

    // For attendance messages, check if conditions are met
    const msg = this.activeAttendanceMessage;

    if (msg.componentData?.type === 'leave') {
      // For leave: require date range, leave type, and file if required
      const hasValidRange = !!(
        msg.componentData?.range?.start && msg.componentData?.range?.end
      );
      const hasLeaveType = !!msg.componentData?.selectedLeaveType;
      const hasFileIfRequired =
        !msg.componentData?.isFileUploadRequired ||
        !!msg.componentData?.selectedFile;

      return hasValidRange && hasLeaveType && hasFileIfRequired;
    }

    if (msg.componentData?.type === 'regularization') {
      // For regularization: require dates and option
      const hasDates = msg.componentData?.selectedDates?.length > 0;
      const hasOption = !!msg.componentData?.selectedOption;

      return hasDates && hasOption;
    }

    return false;
  }

  onAttendanceValidationChange(isValid: boolean, msg: ChatMessage) {
    // Store validation state on the message
    msg.isValidated = isValid;

    // If this is the active attendance message, update disableInput
    if (msg === this.activeAttendanceMessage) {
      this.disableInput = !isValid;
      return;
    }

    if (!this.activeAttendanceMessage) {
      this.disableInput = false;
    }
  }

  onAttendanceComponentDataChange(componentData: any, msg: any) {
    // Preserve original payload fields (e.g. missedPunches) and merge form state.
    msg.componentData = {
      ...(msg.componentData || {}),
      ...componentData,
    };
  }
   getBrowserName(): string {
  const ua = navigator.userAgent;

  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari')) return 'Safari';
  if (ua.includes('OPR') || ua.includes('Opera')) return 'Opera';

  return 'Unknown';
}
  onAttendanceDatesChange(dates: string[], msg: any) {
    msg.selectedDates = dates;

    // Note: Prompt generation is now handled by the attendance component itself
    // The attendance component will emit the prompt via onAttendancePromptChange()
    // We just track the active message
    if (dates.length > 0) {
      this.activeAttendanceMessage = msg;
    } else {
      this.inputMessage = '';
      this.activeAttendanceMessage = null;
      this.disableInput = false;
    }
  }

getTextFromSessionStreamUI(
  sessionId: string,
  query: string,
  scrollContainer: HTMLElement
) {
  let emailId=AppLocalStorage.get('ACCOUNT_DATA', 'ACCOUNT_DATA')?.profile?.email;



  this.newsessionId = sessionId;
  this.disableInput = true;
  this.aiThinking = true;

  /* ---------------- USER MESSAGE ---------------- */
  this.messages.push({
    from: 'user',
    text: query,
    avatar: this.getProfileImageSrc(this.profileimage),
    tagMsg: '',
    tags: [],
    thinking: false,
    timestamp: new Date(),
  });

  /* ---------------- AGENT SKELETON ---------------- */
  this.messages.push({
    from: 'agent',
    text: "<p>Hi i am working on your query <p>" + query ,
    avatar: 'assets/images/thinking.png',
    tagMsg: 'Agent is working',
    tags: Object.keys(this.promptLibrary).sort(),
    thinking: true,
    timestamp: new Date(),
  });

  const agentMsgIndex = this.messages.length - 1;

  let streamedText = '';
  let isAttendanceNode = false;

  let steamResponseObj: { runid: string; response: string }[] = [];

  const runIdCounterMap = new Map<string, number>();

  this.messages[agentMsgIndex].tagMsg = '';
  this.cdr.detectChanges();

  this.ImageString = `<span>
    <svg width="200" height="40" viewBox="0 0 200 40"
      xmlns="http://www.w3.org/2000/svg">...</svg>
  </span>`;

  (async () => {
    const localTime = this.formatFullTime(new Date());
    const client= this.isInTeams ? 'Teams' : this.getBrowserName();

    const stream$ =
      await this.AiChatwootService.getTextFromSessionStream(
        sessionId,
        emailId,
        query,
        this.accessToken,
        localTime,
        client
      );

    stream$.subscribe({
      next: (state: Store.State) => {

        /* ------------ LOADING ------------ */
        if (state instanceof GetChartFromSessionLoadingState) {
          this.aiThinking = true;
          return;
        }

        /* ------------ STREAM START ------------ */
        if (state instanceof GetChartFromSessionChainStartState) {
          this.startStreaming = true;
          return;
        }

        /* ------------ STREAM CHUNK ------------ */
        if (state instanceof GetChartFromSessionStreamChunkState) {
          if (!this.startStreaming) return;

          if (state['node'] === "detect_title_node") {
            return;
          }
          
          /* ===== ATTENDANCE COMPONENT ===== */
          if (state['name'] === 'open_attendance_calendar') {
            
            isAttendanceNode = true;
            

            (this.messages[agentMsgIndex] as any).type = 'attendance';
            this.messages[agentMsgIndex].thinking = false;
            this.calType = 'regularization';
            streamedText += state['content'];

            try {
              const parsed = JSON.parse(streamedText);
              (this.messages[agentMsgIndex] as any).text = '';
              (this.messages[agentMsgIndex] as any).componentData =
                structuredClone(parsed);
              (this.messages[agentMsgIndex] as any).dropdownData =
                  structuredClone(parsed).leaveTypes || [];
            } catch {
              // wait for full JSON
            }

            this.cdr.detectChanges();
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
            return;
          }

          if (state['name'] === 'open_leave_calendar') {
              isAttendanceNode = true;
              this.calType = 'leave';
              (this.messages[agentMsgIndex] as any).type = 'attendance';
              (this.messages[agentMsgIndex] as any).attendanceType = 'leave';
              this.messages[agentMsgIndex].thinking = false;

              streamedText += state['content'];

              try {
                const parsed = JSON.parse(streamedText);
                (this.messages[agentMsgIndex] as any).text = '';
                (this.messages[agentMsgIndex] as any).dropdownData =
                  structuredClone(parsed) || [];
                this.dropdownData = structuredClone(parsed);
              } catch {
                // wait for full JSON
              }

              this.cdr.detectChanges();
              scrollContainer.scrollTop = scrollContainer.scrollHeight;
              return;
            }

          /* ===== NORMAL TEXT (WITH DIFFERENTIATOR) ===== */
          if (!isAttendanceNode) {

            // assign answer number per runid
            if (!runIdCounterMap.has(state['runid'])) {
              runIdCounterMap.set(
                state['runid'],
                runIdCounterMap.size + 1
              );
            }

            const answerNumber =
              runIdCounterMap.get(state['runid'])!;

            const existing = steamResponseObj.find(
              (p) => p.runid === state['runid']
            );

            if (!existing) {
              steamResponseObj.push({
                runid: state['runid'],
                response: state['content'],
              });
            } else {
              existing.response += state['content'];
            }

            streamedText = steamResponseObj
              .map((p, index) => {
                return `
                  <div style="margin-bottom:12px;">
                    ${this.parseMarkdown(p.response)}
                  </div>
                  ${index < steamResponseObj.length - 1 ? '<hr class="chat-divider"/>' : ''}
                `;
              })
              .join('');


            const displayText =
              state.node === 'detect_title_node'
                ? `<p>Hi i am working on your query ${this.ImageString}${streamedText}</p>`
                : streamedText;

            (this.messages[agentMsgIndex] as any).text = displayText;
            this.messages[agentMsgIndex].thinking = false;

            this.cdr.detectChanges();
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
          }
        }

        /* ------------ TOKEN ERROR ------------ */
        if (state instanceof GetTokenErrorState) {
          const displayText = this.parseMarkdown(state['message'] || '');
          (this.messages[agentMsgIndex] as any).text = displayText;
          this.messages[agentMsgIndex].thinking = false;

          this.cdr.detectChanges();
          scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
      },

      /* ------------ ERROR ------------ */
      error: () => {
        this.startStreaming = false;
        this.aiThinking = false;
        this.disableInput = false;

        this.messages[agentMsgIndex].text =
          'Sorry, something went wrong. Please try again.';
        this.messages[agentMsgIndex].thinking = false;

        this.toastrService.danger(
          'Failed to fetch data. Please try again later.',
          'Error',
          { duration: 3000 }
        );

        this.cdr.detectChanges();
      },

      /* ------------ COMPLETE ------------ */
      complete: () => {
        this.startStreaming = false;
        this.aiThinking = false;
        this.disableInput = false;
        this.messages[agentMsgIndex].thinking = false;

        // Set all selected files to error status
          this.selectedFiles.forEach((file) => {
            this.uploadStatusMap[file.name] = 'error';
          });


        if (isAttendanceNode) {
          try {
            (this.messages[agentMsgIndex] as any).componentData =
              structuredClone(JSON.parse(streamedText));

          } catch (e) {
            console.error('Attendance JSON parse error', e);
          }
        } else {
          this.messages[agentMsgIndex].avatar =
            '/assets/images/smiley.png';
        }

        /* ---------- TAG MESSAGE ---------- */
        this.messages[agentMsgIndex].tagMsg =
          'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.';

        this.showOnLoad = true;
        this.SelectLength = this.messages.length;

        /* ---------- FILE RESET (SAFE) ---------- */
        if (!isAttendanceNode && this.allFilesUploaded) {
          this.selectedFiles = [];
          this.isFilesSelected = false;
          this.ulpoadedFilesHtml = [];
          this.uploadStatusMap = {};
          this.uploadProgressMap = {};
          this.inputMessage = '';

          const fileInput = this.fileInput?.nativeElement;
          if (fileInput) {
            fileInput.value = '';
          }

          this.allFilesUploaded = false;
        }
        
        this.cdr.detectChanges();
      },
    });
  })();
}


  showAiThinking(msg, scrollContainer: HTMLElement) {
    this.getChatBotData(msg, scrollContainer)
    this.aiThinking = true;
    // Add a skeleton message
    this.messages.push({
      from: 'agent',
      text: '',
      avatar: 'assets/images/thinking.png',
      tagMsg: 'Feel free to ask me anything. For a quicker start, you can also try one of these common areas.',
      tags: Object.keys(this.promptLibrary).sort(),
                thinking: true,
                timestamp: new Date()
              });    // Simulate AI response after 2s
  }

  removeAiThinking() {
    this.aiThinking = false;
    // Remove the last message if it's a thinking skeleton
    if (this.messages.length && this.messages[this.messages.length - 1].thinking) {
      this.messages.pop();
    }
  }

  trackByMessage(index: number, item: any) { return index; }
  trackByTag(index: number, item: string) { return item; }

  setTheme(theme: string) {
    this.theme = theme as any;
  }

  getThemeIcon(): string {
    const found = this.themes.find(t => t.value === this.theme);
    return found ? found.icon : '';
  }


  toggleOverlay(option?: any) {
    this.showOverlay = !this.showOverlay;
    if (option == 'historySection') {
      this.historySection = true;
      this.userTrackingService.track('LINA_History_clicked', {'value':'Opened'}, 'LINA');
    } else if (option == 'promtSection') {
      this.promtSection = true;
    } else {
      this.promtSection = false;
      this.historySection = false;
    }
    if(this.showOverlayLINA && this.MobileLINAMenu){
      this.showOverlayLINA = false;
      this.MobileLINAMenu = false;
    }
    //popup opened
    this.sidebarService.getSidebarState("menu-" + option).subscribe((state) => {
      if (state === "expanded") {
        this.sidebarService.collapse("menu-" + option);
      } else {
        this.sidebarService.expand("menu-" + option);
      }
    });
  }

  closePopup(option?: any) {
    this.showOverlay = !this.showOverlay;
    this.historySection = false;
    this.promtSection = false;
    this.userTrackingService.track('LINA_History_clicked', {'value':'Closed'}, 'LINA');
  }

  parseMarkdown(text: string): string {
    const html = marked(text || '') as string;
    return html;
  }

  // Speech-to-text methods
  async startRecording() {
    try {
      this.userTrackingService.track('LINA_Speech_To_Text_clicked', {'value':'Start Voice Recording'}, 'LINA');
      this.inputMessage = ''
      this.audioChunks = [];
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(stream);
      this.isRecording = true;

      // Set up audio context for silence detection
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const source = this.audioContext.createMediaStreamSource(stream);
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 256;
      source.connect(this.analyser);

      this.mediaRecorder.addEventListener('dataavailable', (event) => {
        if (event.data.size > 0) {
          this.audioChunks.push(event.data);
        }
      });

      this.mediaRecorder.addEventListener('stop', async () => {
        const audioBlob = new Blob(this.audioChunks, { type: this.mediaRecorder!.mimeType });
        await this.transcribeAudio(audioBlob, this);
        this.cleanupAudioResources();
      });

      this.mediaRecorder.start();
      this.startSilenceDetection();
    } catch (error) {
      this.toastrService.danger('Could not access microphone. Please check permissions.', 'Error', { duration: 3000 });
    }
  }

  stopRecording() {
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop();
      this.isRecording = false;
      this.userTrackingService.track('LINA_Stop_Spech_To_Text_clicked', {'value':'Stop Voice Recording'}, 'LINA');
      // Stop all tracks to release microphone
      this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
      this.cleanupAudioResources();
    }
  }

  private startSilenceDetection() {
    if (!this.analyser) return;

    const bufferLength = this.analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const checkAudioLevel = () => {
      if (!this.isRecording || !this.analyser) return;

      this.analyser.getByteFrequencyData(dataArray);

      // Calculate average volume
      let sum = 0;
      for (let i = 0; i < bufferLength; i++) {
        sum += dataArray[i];
      }
      const average = sum / bufferLength;

      if (average < this.silenceThreshold) {
        // User is silent
        if (!this.silenceTimer) {
          this.silenceTimer = setTimeout(() => {
            if (this.isRecording) {
              this.stopRecording();
            }
          }, this.silenceTimeout);
        }
      } else {
        // User is speaking, clear silence timer
        if (this.silenceTimer) {
          clearTimeout(this.silenceTimer);
          this.silenceTimer = null;
        }
      }

      // Continue monitoring
      if (this.isRecording) {
        requestAnimationFrame(checkAudioLevel);
      }
    };

    checkAudioLevel();
  }

  private cleanupAudioResources() {
    if (this.silenceTimer) {
      clearTimeout(this.silenceTimer);
      this.silenceTimer = null;
    }

    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
      this.audioContext = null;
    }

    this.analyser = null;
  }

  private async transcribeAudio(audioBlob: Blob, me: any) {
    me.inputMessage = '';
    me.isTranscribing = true;
    try {
      const wavBlob = await this.convertToWav(audioBlob);
      this.AiChatwootService.transcribeAudio(wavBlob).subscribe({
        next: (state: Store.State) => {
          if (state instanceof TextSpeakLoadedState) {
            me.inputMessage = state.data.data.text;
            me.LINAInput.nativeElement.focus();
            me.selectedQuestionIndex = 0;
            me.isTranscribing = false;
            me.cdr.detectChanges();
          }
        },
        error: (error) => {
          me.toastrService.danger('Failed to transcribe audio. Please try again.', 'Error', { duration: 3000 });
          me.isTranscribing = false;
          me.cdr.detectChanges();
        }
      });
    } catch (error) {
      me.toastrService.danger('Failed to transcribe audio. Please try again.', 'Error', { duration: 3000 });
      me.isTranscribing = false;
      me.cdr.detectChanges();
    }
  }

  private async convertToWav(blob: Blob): Promise<Blob> {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

    try {
      const arrayBuffer = await blob.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

      const wavBuffer = this.toWav(audioBuffer);
      return new Blob([wavBuffer], { type: 'audio/wav' });
    } catch (error) {
      throw new Error('Failed to convert audio to WAV format');
    } finally {
      // Close AudioContext to prevent memory leaks
      if (audioContext.state !== 'closed') {
        await audioContext.close();
      }
    }
  }

  private toWav(audioBuffer: AudioBuffer): ArrayBuffer {
    const numOfChan = audioBuffer.numberOfChannels;
    const length = audioBuffer.length * numOfChan * 2 + 44;
    const buffer = new ArrayBuffer(length);
    const view = new DataView(buffer);
    const channels: Float32Array[] = [];
    let offset = 0;
    let pos = 0;

    // Write WAV container
    const setUint16 = (data: number) => {
      view.setUint16(pos, data, true);
      pos += 2;
    };

    const setUint32 = (data: number) => {
      view.setUint32(pos, data, true);
      pos += 4;
    };

    setUint32(0x46464952); // "RIFF"
    setUint32(length - 8); // file length - 8
    setUint32(0x45564157); // "WAVE"
    setUint32(0x20746d66); // "fmt " chunk
    setUint32(16); // length of format data
    setUint16(1); // PCM - integer samples
    setUint16(numOfChan); // number of channels
    setUint32(audioBuffer.sampleRate); // sample rate
    setUint32(audioBuffer.sampleRate * 2 * numOfChan); // byte rate
    setUint16(numOfChan * 2); // block align
    setUint16(16); // bits per sample
    setUint32(0x61746164); // "data" - chunk
    setUint32(length - pos - 4); // chunk length

    for (let i = 0; i < numOfChan; i++) {
      channels.push(audioBuffer.getChannelData(i));
    }

    while (pos < length) {
      for (let i = 0; i < numOfChan; i++) {
        // Ensure we don't exceed channel data bounds
        if (offset >= audioBuffer.length) break;

        const sample = Math.max(-1, Math.min(1, channels[i][offset])); // clamp to [-1, 1]
        // Correct 16-bit PCM scaling: -1 to 1 maps to -32768 to 32767
        const scaledSample = Math.round(sample * (sample < 0 ? 32768 : 32767));
        view.setInt16(pos, scaledSample, true); // write 16-bit sample (little-endian)
        pos += 2;
      }
      offset++;

      // Safety check to prevent infinite loop
      if (offset >= audioBuffer.length) break;
    }
    return buffer;
  }

  openLINAMenu(){
    this.MobileLINAMenu = !this.MobileLINAMenu;
    this.showOverlayLINA = !this.showOverlayLINA;
  }

  closeLinaPopup(){
    this.showOverlayLINA = !this.showOverlayLINA;
    this.MobileLINAMenu = !this.MobileLINAMenu;
  }
}
